/**
 * Available tag types
 *
 * @type {Object}
 */
export default {
  container: 'Container',
  particlecontainer: 'ParticleContainer',
  graphics: 'Graphics',
  sprite: 'Sprite',
  tilingsprite: 'TilingSprite',
  text: 'Text',
  ninesliceplane: 'NineSlicePlane',
  rope: 'Rope',
  mesh: 'Mesh',
  plane: 'Plane',
}
